/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Paper, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PageHeaderManage from '../PageHeader/PageHeaderManage';
import { t } from 'i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { addManageRefrsh, updateManageByIdRefresh } from '../../actions/mangeAction';
import { resetError, resetSelectedUser, resetState } from '../../slices/manageSlice';
import { showErrorToast, showSuccessToast } from '../../slices/toastSlice';
import Loader from '../Loader';

const AddConsignee = () => {

    const location = useLocation();
    const state = location.state;
    const { id, item } = state || {};

    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const { updated, added, hasError, errorMessage, loading } = useSelector((state) => state.manage) || {};
    const parentId = searchParams.get('parentId');
    const navigation = useNavigate();



    const validationSchema = yup.object().shape({
        name: yup.string().required('Name is required'),
        street: yup.string().required('Street is required'),
        city: yup.string().required('City is required'),
        country: yup.string().required('Country is required'),
        consigneeNumber: yup.string(),
        email: yup.string().required('Email is required')
            .email('Invalid email'),
        phoneNumber: yup
            .string().required('Phone number is required')
            // .matches(/^\d+$/, 'Phone number must contain only digits')
            .matches(
                /^\+\d{6,14}$/,
                'Phone number is not valid. Please use the format: "+1234567890"'
            ),

    });

    const formik = useFormik({
        initialValues: {
            name: item?.name || '',
            street: item?.street || '',
            city: item?.city || '',
            country: item?.country || '',
            consigneeNumber: item?.consigneeNumber || '',
            email: item?.email || null,
            phoneNumber: item?.phoneNumber || null,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => handleSaveUpdate(values),
        enableReinitialize: true,
    });
    const handleSaveUpdate = (data) => {


        const payload = data

        if (id) {
            dispatch(updateManageByIdRefresh({ mode: 'consignee', id, data: payload }));
            return;
        }
        dispatch(addManageRefrsh({ mode: 'consignee', data: payload, parentId }));

    }

    useEffect(() => {
        return () => {
            dispatch(resetState());
             dispatch(resetError());

        };
    }, []);

    useEffect(() => {


        const mode = "consignee"
        if ((updated || added) && !hasError) {

            if (added) {

                dispatch(showSuccessToast(`The ${mode.toLowerCase()} ${formik.values.name} has been saved successfully`));
            }
            if (updated) {
                dispatch(showSuccessToast(`The ${mode.toLowerCase()} ${item.name} has been updated successfully`));
            }

            navigation(`/${mode}/${parentId ? 'list' : 'view'}` + location.search, {
                state: {
                    showSuccess: true
                }
            });
        }

        if (hasError) {
            dispatch(showErrorToast(`Error: ${errorMessage}`));
            dispatch(resetError());
        }


    }, [updated, added, hasError]);




    const handleKeyDown = (event, submitForm) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            submitForm();
        }
    };


    if (loading === 'pending') {
        return (
            <Loader />
        )
    }

    return (
        <>
            <div onKeyDown={(e) => handleKeyDown(e, formik.submitForm)}>

                <Paper variant='p1'>
                    <PageHeaderManage title={t('Consignee').toUpperCase()} />

                    <Box display='grid' gridTemplateColumns={`${!id ? "repeat(4, 1fr)" : "repeat(3, 1fr)"}`} gap={"20px"} >

                        <TextField
                            label="Name"
                            variant="outlined"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                        <TextField
                            label="Consignee Number"
                            variant="outlined"
                            name="consigneeNumber"
                            value={formik.values.consigneeNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.consigneeNumber && Boolean(formik.errors.consigneeNumber)}
                            helperText={formik.touched.consigneeNumber && formik.errors.consigneeNumber}
                        />
                        <TextField
                            label="Email"
                            name="email"
                            variant="outlined"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                        <TextField
                            label="Phone Number"
                            name="phoneNumber"
                            variant="outlined"
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                            helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                        />

                        <TextField
                            label="Street"
                            name="street"
                            variant="outlined"
                            value={formik.values.street}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.street && Boolean(formik.errors.street)}
                            helperText={formik.touched.street && formik.errors.street}
                        />
                    </Box>
                    <Box display='grid' gridTemplateColumns={"repeat(4, 1fr)"} marginY={"40px"} gap={"20px"} >

                        <TextField
                            label="City"
                            name="city"
                            variant="outlined"
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.city && Boolean(formik.errors.city)}
                            helperText={formik.touched.city && formik.errors.city}
                        />

                        <TextField
                            label="Country"
                            name="country"
                            variant="outlined"
                            value={formik.values.country}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.country && Boolean(formik.errors.country)}
                            helperText={formik.touched.country && formik.errors.country}
                        />


                        <Box display='grid' gridTemplateColumns={"repeat(2, 1fr)"} alignItems='center'>
                            <Button variant="b2" sx={{
                                marginInline: '20px'
                            }} onClick={() => {
                                navigate('/consignee/list?' + searchParams.toString());
                                dispatch(resetSelectedUser())
                            }} >Cancel</Button>

                            <Button variant="b1" onClick={formik.handleSubmit}>Save</Button>

                        </Box>
                    </Box>
                </Paper>
            </div>

        </>
    )
}

export default AddConsignee